import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, CloudOff, Loader2, SlidersHorizontal } from "lucide-react";
import SetupSummary from "@/components/recstudio/SetupSummary";

const SAVE = { saved: ["Saved", Check, "text-emerald-200"], saving: ["Saving…", Loader2, "text-white/60"], error: ["Not saved", CloudOff, "text-rose-200"] };

/** Session title (editable), save state, setup chips and the hand-off to the 64-channel Advanced mode. */
export default function WorkspaceHeader({ doc, setup, saveState, syncing, onTitle, onSetup }) {
  const [title, setTitle] = useState(doc.title);
  useEffect(() => setTitle(doc.title), [doc.title]);
  const [label, Icon, tone] = SAVE[saveState] || SAVE.saved;
  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
      <div className="min-w-0 flex-1">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-rose-300/90">ELPM Advanced Studio · Smart Recording</p>
        <input data-testid="rec-session-title" value={title} maxLength={120} onChange={(e) => setTitle(e.target.value)} onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()} onBlur={() => title.trim() && title !== doc.title && onTitle(title.trim())}
          className="mt-2 w-full bg-transparent font-display text-3xl font-bold leading-tight focus:outline-none sm:text-4xl" aria-label="Session name" />
        <p className="mt-2 flex flex-wrap items-center gap-3 font-mono text-[10px] uppercase tracking-wider">
          <span data-testid="rec-save-state" data-state={saveState} className={`inline-flex items-center gap-1 ${tone}`}><Icon className={`h-3 w-3 ${saveState === "saving" ? "animate-spin" : ""}`} /> {label}</span>
          {syncing ? <span data-testid="rec-syncing" className="inline-flex items-center gap-1 text-sky-200"><Loader2 className="h-3 w-3 animate-spin" /> Loading audio…</span> : null}
        </p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <SetupSummary compact setup={setup} onSetup={onSetup} />
        <Link to="/studio" data-testid="rec-open-advanced" title="Your session tracks open as channels in the 64-channel studio"
          className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/[0.05] px-4 py-1.5 text-[12px] text-white/85 transition-colors duration-200 hover:bg-white/[0.12]">
          <SlidersHorizontal className="h-3.5 w-3.5" /> Advanced mode
        </Link>
      </div>
    </div>
  );
}
